<script setup lang="ts">
    type ErrorReason = 'invalidId' | 'notReleased' | 'notFound';

    type Props = {
        imageId?: number | null;
        name?: string;
        linkTo?: string;
        isPrescriptionOnly?: boolean;
        invalidId?: boolean;
        errorReason?: ErrorReason;
    };

    const {
        imageId = null,
        name = '',
        linkTo = '',
        isPrescriptionOnly = false,
        invalidId = false,
        errorReason = 'invalidId'
    } = defineProps<Props>();

    const { t } = useI18n();

    const fallbackTitle = computed(() => {
        if (errorReason === 'notReleased') {
            return t('productCard.notReleased');
        }

        if (errorReason === 'notFound') {
            return t('productCard.notFound');
        }

        return t('productCard.invalidId');
    });
</script>

<template>
    <div
        class="product-card"
        data-testid="fachportal-product-card"
    >
        <div class="content-wrapper">
            <NuxtLink
                class="image-wrapper"
                data-testid="fachportal-product-card-image-link"
                :to="linkTo"
            >
                <div
                    v-if="isPrescriptionOnly"
                    class="badge"
                >
                    {{ t('productCard.isPrescriptionOnly') }}
                </div>

                <CenshareImage
                    :image-id="imageId"
                    :invalid-id="invalidId"
                    :name="name"
                    type="productCard"
                />
            </NuxtLink>
            <h3>{{ name ? name : fallbackTitle }}</h3>
        </div>

        <div class="cta-wrapper">
            <PrimaryButton
                v-if="linkTo"
                :button-text="t('productCard.toDetailPage')"
                :force-product-styling="true"
                :button-href="linkTo"
            />
        </div>
    </div>
</template>

<style scoped>
    @import '~/assets/scss/fachkreis/fachkreis-product-card.scss';
</style>
